import { render, staticRenderFns } from "./Game_mental_rotation.vue?vue&type=template&id=b8202dbe&style=true"
import script from "./Game_mental_rotation.vue?vue&type=script&lang=js"
export * from "./Game_mental_rotation.vue?vue&type=script&lang=js"
import style0 from "./Game_mental_rotation.vue?vue&type=style&index=0&id=b8202dbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports